module.exports = __webpack_public_path__ + "static/media/tianshangshan_web.45c363ff.png";